import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirecionaDownloadRelatorio = ({ match }) => <Redirect to={`/isa/download-relatorio/${match.params.id}`} />;

export default RedirecionaDownloadRelatorio;
